import React from "react"
import logoDM from "../../assets/images/venue-nav-logo-derby-museums.svg"
import logoMAG from "../../assets/images/venue-nav-logo-museum-and-art-gallery.svg"
import logoMOM from "../../assets/images/venue-nav-logo-museum-of-making.svg"
import logoPH from "../../assets/images/venue-nav-logo-pickfords-house.svg"

// Styles
import * as styles from "./NavigationVenue.module.scss"

const NavigationVenue = (props) => {
    const currentVenue = props.venue

    return <ul className={`${styles.NavigationVenue} venue${currentVenue.theme}`}>
        {currentVenue.theme != 'DM' &&
        <li className={styles.DM}><a href='/'><img src={logoDM} alt="Logo"/></a></li>
        }
        <li className={`${styles.MAG} ${currentVenue.theme == 'MAG' ? styles.isCurrent : ''}`}><a href='/museum-and-art-gallery'><img src={logoMAG} alt="Logo"/></a></li>
        <li className={`${styles.MOM} ${currentVenue.theme == 'MOM' ? styles.isCurrent : ''}`}><a href='/museum-of-making'><img src={logoMOM} alt="Logo"/></a></li>
        <li className={`${styles.PH} ${currentVenue.theme == 'PH' ? styles.isCurrent : ''}`}><a href='/pickfords-house'><img src={logoPH} alt="Logo"/></a></li>
    </ul>

}

export default NavigationVenue